var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "history-edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_13",
    "data-name": "Ellipse 13",
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#ee8737"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473",
    transform: "translate(9.471 8.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    d: "M0,0H11.679a2.664,2.664,0,0,1,2.664,2.664v0a2.664,2.664,0,0,1-2.664,2.664H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(2.941 10.142) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M479.649,1010.071h0a4.339,4.339,0,0,0-1.209,2.337l-.441,2.573a.44.44,0,0,0,.508.508l2.573-.44a4.344,4.344,0,0,0,2.337-1.21h0Z",
    transform: "translate(-477.992 -998.644)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryEdit);
export default __webpack_public_path__ + "static/media/history-edit.f41b832f5058cc0f9679c7e590495fb4.svg";
export { ForwardRef as ReactComponent };